import React from 'react';
import Button from '@components/ui/Button';
import Select from '@components/ui/Select';
import Icon from '@components/AppIcon';

const LocationFilter = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  totalLocations, 
  filteredCount 
}) => {
  const serviceOptions = [
    { value: '', label: 'All Services' },
    { value: 'general', label: 'General Eye Check-Up' },
    { value: 'cataract', label: 'Cataract Surgery' },
    { value: 'lasik', label: 'LASIK & Refractive Surgery' },
    { value: 'glaucoma', label: 'Glaucoma Management' },
    { value: 'retina', label: 'Retina Care' },
    { value: 'cornea', label: 'Cornea Care' },
    { value: 'keratoconus', label: 'Keratoconus Treatment' },
    { value: 'squint', label: 'Squint (Strabismus) Treatment' },
    { value: 'refractive', label: 'Refractive Error Correction' },
    { value: 'optical', label: 'Optical Services' }
  ];

  const areaOptions = [
    { value: '', label: 'All Branches' },
    { value: 'westlands', label: 'Westlands Main Branch' },
    { value: 'eastleigh', label: 'Eastleigh Branch' },
    { value: 'nakuru', label: 'Nakuru Branch' }
  ];

  const featureOptions = [
    { value: '', label: 'All Features' },
    { value: 'emergency', label: 'Emergency Care (During Opening Hours)' },
    { value: 'parking', label: 'Free Parking' },
    { value: 'wheelchair', label: 'Wheelchair Access' },
    { value: 'pharmacy', label: 'On-site Pharmacy' },
    { value: 'surgery', label: 'Surgery Suite' }
  ];

  const hasActiveFilters = filters.service || filters.area || filters.feature;

  const buttonClass = (isActive) =>
    `flex items-center space-x-2 px-4 py-2 rounded-lg font-medium text-sm transition-colors duration-200 ${
      isActive
        ? 'bg-[#eb2227] text-white'
        : 'bg-gray-100 text-[#08005f] hover:bg-[#08005f] hover:text-white'
    }`;

  return (
    <div className="bg-white rounded-xl shadow-md p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading font-bold text-xl text-[#08005f] mb-1">
            Find Your Nearest Branch
          </h2>
          <p className="text-[#08005f]">
            Showing {filteredCount} of {totalLocations} locations
          </p>
        </div>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
            iconSize={16}
            className="border-[#08005f] text-[#08005f] hover:bg-[#08005f] hover:text-white"
          >
            Clear Filters
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <Select
          label="Service Needed"
          options={serviceOptions}
          value={filters.service}
          onChange={(value) => onFilterChange('service', value)}
          placeholder="Select a service"
        />
        <Select
          label="Branch"
          options={areaOptions}
          value={filters.area}
          onChange={(value) => onFilterChange('area', value)}
          placeholder="Select a branch"
        />
        <Select
          label="Features"
          options={featureOptions}
          value={filters.feature}
          onChange={(value) => onFilterChange('feature', value)}
          placeholder="Select features"
        />
      </div>

      {/* Quick Filter Buttons */}
      <div className="flex flex-wrap gap-2">
        <button
          className={buttonClass(filters.feature === 'emergency')}
          onClick={() =>
            onFilterChange('feature', filters.feature === 'emergency' ? '' : 'emergency')
          }
        >
          <Icon name="AlertCircle" size={16} />
          Emergency Care (During Opening Hours)
        </button>

        <button
          className={buttonClass(filters.service === 'lasik')}
          onClick={() =>
            onFilterChange('service', filters.service === 'lasik' ? '' : 'lasik')
          }
        >
          <Icon name="Eye" size={16} />
          LASIK & Refractive Surgery
        </button>

        <button
          className={buttonClass(filters.feature === 'parking')}
          onClick={() =>
            onFilterChange('feature', filters.feature === 'parking' ? '' : 'parking')
          }
        >
          <Icon name="Car" size={16} />
          Free Parking
        </button>

        <button
          className={buttonClass(filters.service === 'pediatric')}
          onClick={() =>
            onFilterChange('service', filters.service === 'pediatric' ? '' : 'pediatric')
          }
        >
          <Icon name="Baby" size={16} />
          Child-Friendly
        </button>
      </div>
    </div>
  );
};

export default LocationFilter;
